<template>
        <div class="offers-slider">
            
            <openpay-charge ref="openPayModal" />

            <a class="swiper-button-prev sw-btn-prev-s1"></a>
            <a class="swiper-button-next sw-btn-next-s1"></a>

            <swiper class="swiper swiper-packs-s1 sw-carousel-s2 sw-pack-s2" :options="$root.swPackOpts">

                <swiper-slide v-for="(pa, paInx) in filtered" :key="'paInx-' + paInx">

                    <div class="col-12 box-pack-s1">

                    <div class="col-12 col-image" v-if="!!pa.imagenes_id">
                        <!-- <img :src="pa.img" alt="" /> -->
                        <api-img :comp="pa.imagenes_id" />
                    </div>

                    <div class="col col-l" :class="{ 'c-1': pa.nChars == 1, 'c-2': pa.nChars == 2, 'c-3': pa.nChars == 3, }">
                        
                        <h5 class="days">
                            {{pa.days}} Días
                        </h5>

                        <h5 class="gbs">
                        <i class="i-speed"></i> <span>{{ pa.gbs }}</span>
                        </h5>

                        <h5 class="hotspot" v-if="pa.hotspot == '1'">
                        <i class="i-hotspot"></i> <span>Hotspot</span>
                        </h5>

                        <h5 class="monthly" v-if="pa.monthly == '1'">
                        <i class="i-monthly"></i> <span>Por Mes</span>
                        </h5>

                    </div>

                    <div class="col col-r">

                        <h6 class="s-name">{{ pa.planName }}</h6>

                        <div class="descr">
                            <vue-simple-markdown :source="pa.descr"/>
                        </div>

                        <div class="box-price">
                            <!-- <div class="price" v-bind:class="{ monthly: pa.monthly }">
                                <div>
                                    <div class="txt-1">
                                        {{ pa.precio | currency }}
                                        <template v-if="pa.monthly == '1'">
                                            <br>
                                            <span>Por Mes</span>
                                        </template>
                                    </div>
                                </div>
                            </div> -->
                            <a @click="$refs.openPayModal.setForPayment(pa)" class="t-250 btn-rent price" >
                                <span>Comprar {{ pa.precio | currency }}</span>
                            </a>
                        </div>

                    </div>

                    </div>

                </swiper-slide>
            
            </swiper>

        </div>
</template>

<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from "vuex";
    import openpayCharge from './openpay-charge.vue';

	export default {
        components: { openpayCharge },
        props: {
            ofertaTipo: {
                type: String,
                default: 'planMovil'
            }
        },
        computed: {
                ...mapGetters(['OfertaGetCatalogo']),
                filtered(){
                    return _.filter(this.OfertaGetCatalogo, {tipo: this.ofertaTipo})
                }
        },

        data() {
            return {
            // == Carousel options ==
            // == ==
            };
        }

	};
</script>

<style>
.box-pack-s1 .col-r .box-price .price.btn-rent {
    box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
              0 2px 2px rgba(0,0,0,0.12), 
              0 4px 4px rgba(0,0,0,0.12);
}
.box-pack-s1 .col-r .box-price .price.btn-rent:hover {
    box-shadow: 0 1px 1px rgb(16 27 30 / 15%), 0 2px 2px rgb(16 27 30 / 15%), 0 4px 4px rgb(16 27 30 / 15%), 0 8px 8px rgb(16 27 30 / 15%), 0 16px 16px rgb(16 27 30 / 15%);
}
</style>
